export const MinLocationSummaryCharacters = 200;
export const MinimumPhotosAndVideos = 80;
// Need 15-20 to fill two rows if the photos are all portrait.
export const MinimumHighlights = 17;

